import { updateImageGalleryOnboardDismissed } from "../../store/actionCreators";
import { updateImageGalleryOnboardDismissedReducer } from "../reducers";

export const registerUiSlice = (builder) => {
  builder.addCase(
    updateImageGalleryOnboardDismissed,
    updateImageGalleryOnboardDismissedReducer,
  );
};
